module.exports = __webpack_public_path__ + "img/08-the-pathway-to-a-socially.eb5dbeef.png";